export const Endpoint = "chat/change-chat-channel-handle";
export const Method = "GET";
